<template>
    <div>
    <div style="margin-top: 10px;" v-for="sms_comment in smsCommentArray" :key="sms_comment.commentText">
            <div style="display: flex; flex-direction: row; justify-content: space-between">
                <div>
                    Commented by: <span class="has-text-weight-medium">{{ sms_comment.sms_commented_by }}</span>
                </div>
                <div>
                    <span>{{ sms_comment.sms_commented_at }}</span>
                </div>
            </div>
        <div>
            <b-input style="margin-top: 10px;" type="text" v-model="sms_comment.sms_comment" readonly/>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "SmsCommentField",

    props: {
        smsCommentArray : Array
    }
}
</script>

<style scoped>

*{
    color: gray;
}

</style>